import { toast } from 'sonner';

export class DisplayToast {
  static success(message: string) {
    toast.success(message);
  }

  static notice(message: string) {
    toast.success(message);
  }

  static error(message?: string) {
    toast.error(message || 'Щось пішло не так', {
      style: { background: 'var(--destructive)' },
    });
  }
}
